import React, { ReactNode } from "react";
import { Refresh } from "@bloomberg/media-ui-icons";
import styles from "./styles.module.css";
import Notification from "~components/Notification";

interface PlaceholderWithErrorProps {
  placeholder: ReactNode;
  errorMessage: string;
  onRetryClick: () => void;
}

export const PlaceholderWithError = ({
  placeholder,
  errorMessage,
  onRetryClick,
}: PlaceholderWithErrorProps) => {
  return (
    <div className={styles.placeholderWithError}>
      <div className={styles.placeholderContainer}>{placeholder}</div>
      <div className={styles.errorContainer}>
        <Notification
          text={errorMessage}
          variant="lineBreak"
          title=""
          actionIcon={<Refresh />}
          actionText="Retry"
          onActionClick={onRetryClick}
        />
      </div>
    </div>
  );
};
